import { Edit } from '@mui/icons-material';
import { Card, CardContent, CardHeader, IconButton } from '@mui/material';
import { FC, useCallback } from 'react';
import {
  EmailField,
  FieldProps,
  Loading,
  TextField,
  useRecordContext,
  useShowController,
} from 'react-admin';
import { useNavigate } from 'react-router-dom';

export const FeedShow: FC = () => {
  const data = useShowController();
  const navigate = useNavigate();
  const {
    record: {
      id,
      name,
      description,
      header_url,
      header_mobile_url,
      header_css,
      header_icon,
    } = {},
    isLoading,
    isFetching,
  } = data;

  const handleClickEdit = useCallback(() => {
    navigate(`/feed/${id}`);
  }, [id, navigate]);

  const TypeField = (props: FieldProps) => {
    const value = useRecordContext(props);
    const { type } = value;
    if (String(type) === 'headings') {
      return <span>Рубрика</span>;
    }
    if (String(type) === 'course') {
      return <span>Курс</span>;
    }
    if (String(type) === 'mashtab') {
      return <span>Масштаб</span>;
    }
    if (String(type) === 'challenge') {
      return <span>Челлендж</span>;
    }
    return <span>Неизвестно</span>;
  };

  if (isLoading || isFetching) {
    return <Loading />;
  }
  return (
    <Card>
      <CardHeader
        title={`${name}`}
        subheader={description}
        action={
          <IconButton aria-label="Edit" onClick={handleClickEdit}>
            <Edit />
          </IconButton>
        }
      />
      <CardContent>
        <EmailField source="header_url" record={data.record} />
        <TextField source="header_mobile_url" record={data.record} />
        <TextField source="header_css" record={data.record} />
        <TextField source="header_icon" record={data.record} />
      </CardContent>
    </Card>
  );
};
